import { render, staticRenderFns } from "./SearchShop.vue?vue&type=template&id=058d3640&scoped=true"
import script from "./SearchShop.vue?vue&type=script&lang=ts"
export * from "./SearchShop.vue?vue&type=script&lang=ts"
import style0 from "./SearchShop.vue?vue&type=style&index=0&id=058d3640&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058d3640",
  null
  
)

export default component.exports